import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatDialogModule} from "@angular/material/dialog";
import {RewardRedeemConfirmationDialogComponent} from "./reward-redeem-confirmation-dialog.component";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatDividerModule} from "@angular/material/divider";
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {CardOverlayModule} from "@pages/user/partials/card-overlay/card-overlay.module";
import {
  RewardRedeemConfirmationModule
} from "@app/feature/reward/reward-redeem-confirmation/reward-redeem-confirmation.module";


@NgModule({
  declarations: [RewardRedeemConfirmationDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDividerModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    MatAutocompleteModule,
    CardOverlayModule,
    RewardRedeemConfirmationModule
  ],
  exports: [RewardRedeemConfirmationDialogComponent]
})

export class RewardRedeemConfirmationDialogModule { }
